export const data = [
    {
    id: "recAGJfiU4CeaV0HL",
    order: 3,
    title: "Developpeur Web Full Stack",
    dates: "Septembre 2017 - Présent",
    duties: [
    "Développer des applications Web à pile complète qui traitent, analysent et rendent les données visuellement.",
    "Assurer la liaison avec les développeurs back-end, les développeurs front-end, les testeurs d'assurance qualité et le CTO selon les besoins.",
    "Gestion des mises à jour urgentes, y compris les modifications de contenu et les mises à niveau de la base de données à planifié, écrit et débogué des applications Web et des logiciels avec une précision totale"
    ],
    company: "Developpeur Full-Stack"
    },
    {
    id: "recIL6mJNfWObonls",
    order: 2,
    title: "Deveppeur Mobile",
    dates: "Mai 2019 - Présent",
    duties: [
    "L'utilisation de Java, Python ave le framework Android, le framework Flutter. Les développements de applications mobiles hybrides et multiplateforme.",
    "Assurer le développement des produits dans les délais et un travail de qualité pour apporter une amélioration continue.",
    "Fournir une expertise technique dans plusieurs domaines de développement d'applications grâce aux technologies : react-native, redux, sql, flutter."
    ],
    company: "Developpeur mobile"
    },
    {
    id: "rec61x18GVY99hQq5",
    order: 1,
    title: "Design UX/UI",
    dates: "Juillet 2020 - à présent",
    duties: [
    "La création des interfaces utilisateur modernes et progressives. Faire une traduction artistique globale, et de mettre en page les contenus à destination d’écrans (web, mobiles, tablettes) en lien avec le contenu du site. ainsi la conception de l’identité visuelle d’un site."
    ],
    company: "Concepteur UI/UX"
    },
    
]